<template>
  <div class="mt-3" style="font-size: 80%">
    <div class="accordion mb-2" id="accordionCondiciones">
      <div class="shadow">
        <button
          class="btn btn-success btn-sm w-100"
          @click="buttonNuevo()"
          type="button"
          data-toggle="collapse"
          data-target="#collapseCondiciones"
          aria-expanded="false"
          aria-controls="collapseCondiciones"
        >
          <i class="fas fa-plus-circle"></i>
          {{ tipo === 'PAGO' ? 'Nueva Condición de Pago' : 'Nueva Condición de Cobro' }}
        </button>

        <div
          id="collapseCondiciones"
          class="collapse"
          aria-labelledby="headingCondiciones"
          data-parent="#accordionCondiciones"
        >
          <div class="w-100 card-body shadow rounded bg-light">
            <b-form @submit.prevent="procesarFormulario">
              <div class="container">
                <div class="form-row mb-3">
                  <b-col cols="12">
                    <label for="nombre" class="form-label font-weight-bold">Nombre de la Condición (Ej: 30/50/20)</label>
                    <b-form-input
                      class="form-control"
                      size="sm"
                      v-model="form.nombre"
                      id="nombre"
                      required
                    ></b-form-input>
                  </b-col>
                </div>

                <!-- Sección de Hitos (Solo para PAGO) -->
                <div class="mt-4" v-if="tipo === 'PAGO'">
                  <div class="d-flex justify-content-between align-items-center mb-2">
                    <strong class="text-secondary">Hitos de Facturación</strong>
                    <b-button size="sm" variant="success" @click="agregarHitoForm" title="Añadir hito">
                      <i class="fas fa-plus"></i> Añadir Hito
                    </b-button>
                  </div>

                  <div v-for="(hito, idx) in form.hitos" :key="idx" class="form-row mb-2 p-2 border rounded bg-white align-items-center">
                    <b-col cols="2">
                      <label class="small font-weight-bold mb-1">Porcentaje</label>
                      <b-form-input size="sm" v-model="hito.porcentaje" placeholder="30%" required></b-form-input>
                    </b-col>
                    <b-col cols="4">
                      <label class="small font-weight-bold mb-1">Descripción (ES)</label>
                      <b-form-input size="sm" v-model="hito.descripcion" placeholder="A la firma..." required></b-form-input>
                    </b-col>
                    <b-col cols="5">
                      <label class="small font-weight-bold mb-1">Description (EN)</label>
                      <b-form-input size="sm" v-model="hito.description" placeholder="Upon signature..."></b-form-input>
                    </b-col>
                    <b-col cols="1" class="text-right pt-4">
                      <b-button size="sm" variant="link" class="text-danger p-0 shadow-none" @click="eliminarHitoForm(idx)">
                        <i class="fas fa-trash"></i>
                      </b-button>
                    </b-col>
                  </div>
                </div>

                <!-- Sección Simplificada (Solo para COBRO) -->
                <div class="mt-4" v-else>
                  <b-row v-if="form.hitos && form.hitos.length > 0">
                    <b-col md="6">
                      <label for="descripcionCobro" class="form-label font-weight-bold">Descripción (ES)</label>
                      <b-form-textarea
                        id="descripcionCobro"
                        v-model="form.hitos[0].descripcion"
                        rows="3"
                        placeholder="Escriba aquí la condición de cobro en español..."
                        required
                        size="sm"
                      ></b-form-textarea>
                    </b-col>
                    <b-col md="6">
                      <label for="descriptionCobro" class="form-label font-weight-bold text-muted">Description (EN)</label>
                      <b-form-textarea
                        id="descriptionCobro"
                        v-model="form.hitos[0].description"
                        rows="3"
                        placeholder="Write here the collection condition in English..."
                        size="sm"
                      ></b-form-textarea>
                    </b-col>
                  </b-row>
                </div>
              </div>

              <div class="d-flex justify-content-end mt-4">
                <b-button
                  variant="outline-danger"
                  size="sm"
                  class="mr-2"
                  data-toggle="collapse"
                  data-target="#collapseCondiciones"
                  @click="resetForm()"
                  ><i class="far fa-times-circle mr-1"></i>Cancelar</b-button
                >
                <b-button
                  variant="primary"
                  size="sm"
                  type="submit"
                  data-toggle="collapse"
                  data-target="#collapseCondiciones"
                  ><i class="far fa-check-circle mr-1"></i>{{ editando ? 'Actualizar' : 'Guardar' }}</b-button
                >
              </div>
            </b-form>
          </div>
        </div>
      </div>
    </div>

    <div class="overflow-auto mt-3">
      <b-table
        responsive
        head-variant="light"
        :fields="camposTabla"
        :items="items"
        small
        hover
      >
        <template #cell(hitos)="row">
          <div v-if="tipo === 'COBRO' && row.value && row.value.length > 0">
            {{ row.value[0].descripcion }}
          </div>
          <ul class="mb-0 pl-3" v-else-if="tipo === 'PAGO'">
            <li v-for="(h, i) in row.value" :key="i">
              <strong>{{ h.porcentaje }}</strong>: {{ h.descripcion }} <span v-if="h.description" class="text-muted small">({{ h.description }})</span>
            </li>
          </ul>
        </template>
        <template #cell(accion)="row">
          <b-button-group size="sm">
            <b-button
              size="sm"
              variant="outline-success"
              data-toggle="collapse"
              data-target="#collapseCondiciones"
              @click="buttonEditar(row.item)"
              class="mr-1"
            >
              <i class="fas fa-edit"></i>
            </b-button>

            <b-button
              size="sm"
              variant="outline-danger"
              @click="eliminar(row.item)"
            >
              <i class="fas fa-trash-alt"></i>
            </b-button>
          </b-button-group>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import { api1 } from "@/lib/http";

export default {
  name: "CondicionesPagoMaintenanceComponent",
  props: {
    tipo: {
      type: String,
      default: 'PAGO'
    }
  },
  data() {
    return {
      editando: false,
      form: {
        id: null,
        nombre: "",
        tipo: this.tipo,
        hitos: [{ porcentaje: "", descripcion: "", description: "" }]
      },
      items: [],
    };
  },
  computed: {
    camposTabla() {
      const labelHitos = this.tipo === 'COBRO' ? 'Descripción' : 'Hitos asociados';
      return [
        { key: "nombre", label: "Condición", sortable: true, thStyle: { width: "30%" } },
        { key: "hitos", label: labelHitos, sortable: false },
        { key: "accion", label: "", thStyle: { width: "100px" } },
      ];
    }
  },
  methods: {
    async obtenerItems() {
      try {
        const { data } = await api1.get(`/api/dekra-projects/v204/condiciones-pago?tipo=${this.tipo}`);
        this.items = data;
      } catch (error) {
        console.error("Error obteniendo condiciones de pago:", error);
      }
    },
    procesarFormulario() {
      if (this.editando) {
        this.actualizar();
      } else {
        this.guardar();
      }
    },
    async guardar() {
      try {
        await api1.post("/api/dekra-projects/v204/condiciones-pago", this.form);
        this.obtenerItems();
        this.resetForm();
      } catch (error) {
        console.error("Error al guardar:", error);
      }
    },
    async actualizar() {
      try {
        await api1.put(`/api/dekra-projects/v204/condiciones-pago/${this.form.id}`, this.form);
        this.obtenerItems();
        this.resetForm();
      } catch (error) {
        console.error("Error al actualizar:", error);
      }
    },
    async eliminar(item) {
      if (!confirm("¿Seguro que quieres borrar esta condición de pago?")) return;
      try {
        await api1.delete(`/api/dekra-projects/v204/condiciones-pago/${item.id}`);
        this.obtenerItems();
      } catch (error) {
        console.error("Error al eliminar:", error);
      }
    },
    buttonNuevo() {
      this.editando = false;
      this.resetForm();
      this.agregarHitoForm(); // Start with one empty hito
    },
    buttonEditar(item) {
      this.editando = true;
      // Clona para evitar modificar el objeto de la tabla directamente
      this.form = JSON.parse(JSON.stringify(item));
      if (this.tipo === 'COBRO' && (!this.form.hitos || this.form.hitos.length === 0)) {
        this.form.hitos = [{ porcentaje: "", descripcion: "", description: "" }];
      }
    },
    resetForm() {
      this.form = {
        id: null,
        nombre: "",
        tipo: this.tipo,
        hitos: [{ porcentaje: "", descripcion: "", description: "" }]
      };
    },
    agregarHitoForm() {
      this.form.hitos.push({ porcentaje: "", descripcion: "", description: "" });
    },
    eliminarHitoForm(idx) {
      this.form.hitos.splice(idx, 1);
    }
  },
  mounted() {
    this.obtenerItems();
  }
};
</script>
